import ViewportObserverService from "Services/ViewportObserverService";
import { IN_VP_EVENT } from "Constants/eventNames";
import { LOADED } from "Constants/cssClasses";

class ZhiIcon extends HTMLElement {

  connectedCallback() {
    ViewportObserverService.observe(this);
    this.addEventListener(IN_VP_EVENT, () => this.loadIcon());
  }

  get iconId() {
    return this.getAttribute("icon-id") || "";
  }

  async loadIcon() {
    const symbol = await import(
      /* webpackChunkName: "zhi-icon-" */
      `Icons/${this.iconId}.svg`
    )
      .then(({ default: icon }) => {
        return icon;
      })
      .catch((error) => {
        console.warn(`An error occurred while loading the component: ${error}`);
        this.remove();
      });

    this.appendSymbol(symbol);
  }

  appendSymbol(symbol) {
    const svgTempBox = document.createElement("span");
    // svgTempBox.innerHTML = `<style>${vicIconShadowScss}</style>${symbol}`;
    svgTempBox.innerHTML = `${symbol}`;
    const svgRoot = svgTempBox.querySelector("svg");
    if (svgRoot !== null) {
      svgRoot.setAttribute("class", "zhi-icon__svg");
    }
    this.innerHTML = svgTempBox.innerHTML;
  }
}

customElements.define("zhi-icon", ZhiIcon);